import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class VerticalDayTimesheetComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 300.0;
        const componentHeightRatio = component.height / 900.0;

        const smallHeight = 50 * componentHeightRatio * dimentionsRatio;
        const bigHeight = 200 * componentHeightRatio * dimentionsRatio;
        const width = 200 * componentWidthRatio * dimentionsRatio;

        const elementsPosX = component.drawPositionX + 50 * componentWidthRatio * dimentionsRatio;

        const descriptionPosY = component.drawPositionY + 50 * componentHeightRatio * dimentionsRatio;
        let tableElementPosY = component.drawPositionY + 300 * componentHeightRatio * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        const rowElements = [];
        let i;
        for (i = 0; i < 6; i++) {
            rowElements.push(
                <Rect key={i}
                    x={elementsPosX}
                    y={tableElementPosY}
                    width={width}
                    height={smallHeight}
                    strokeWidth={1}
                    stroke="black"
                    fill={componentSecundaryColor} />
            );

            tableElementPosY += smallHeight + 50 * componentHeightRatio * dimentionsRatio;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={width}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    {rowElements}
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VerticalDayTimesheetComponentCanvas.js